import gql from 'graphql-tag';

export default gql`
    mutation AddFacilityToLofa($input: LofaScheduleEdit) {
        addFacilityToLofa(input: $input) {
            errors
        }
    }
`;
